__turbopack_export_value__({
  "body-logo-18": "ControlledTextArea-module-scss-module__VnJNyG__body-logo-18",
  "body-text-12": "ControlledTextArea-module-scss-module__VnJNyG__body-text-12",
  "body-text-14": "ControlledTextArea-module-scss-module__VnJNyG__body-text-14",
  "body-text-16": "ControlledTextArea-module-scss-module__VnJNyG__body-text-16",
  "body-text-18": "ControlledTextArea-module-scss-module__VnJNyG__body-text-18",
  "body-text-20": "ControlledTextArea-module-scss-module__VnJNyG__body-text-20",
  "body-text-24": "ControlledTextArea-module-scss-module__VnJNyG__body-text-24",
  "body-text-24-2": "ControlledTextArea-module-scss-module__VnJNyG__body-text-24-2",
  "body-text-heading-2": "ControlledTextArea-module-scss-module__VnJNyG__body-text-heading-2",
  "body-text-heading-3": "ControlledTextArea-module-scss-module__VnJNyG__body-text-heading-3",
  "body-text-medium-14": "ControlledTextArea-module-scss-module__VnJNyG__body-text-medium-14",
  "body-text-medium-16": "ControlledTextArea-module-scss-module__VnJNyG__body-text-medium-16",
  "body-text-medium-18": "ControlledTextArea-module-scss-module__VnJNyG__body-text-medium-18",
  "body-text-medium2-18": "ControlledTextArea-module-scss-module__VnJNyG__body-text-medium2-18",
  "body-text2-14": "ControlledTextArea-module-scss-module__VnJNyG__body-text2-14",
  "body-text2-16": "ControlledTextArea-module-scss-module__VnJNyG__body-text2-16",
  "button-primary-text": "ControlledTextArea-module-scss-module__VnJNyG__button-primary-text",
  "button-text": "ControlledTextArea-module-scss-module__VnJNyG__button-text",
  "button2-text": "ControlledTextArea-module-scss-module__VnJNyG__button2-text",
  "card-shadow": "ControlledTextArea-module-scss-module__VnJNyG__card-shadow",
  "cross": "ControlledTextArea-module-scss-module__VnJNyG__cross",
  "cross_shifted": "ControlledTextArea-module-scss-module__VnJNyG__cross_shifted",
  "effect-menu": "ControlledTextArea-module-scss-module__VnJNyG__effect-menu",
  "errorHint": "ControlledTextArea-module-scss-module__VnJNyG__errorHint",
  "errorHint_visible": "ControlledTextArea-module-scss-module__VnJNyG__errorHint_visible",
  "header-1": "ControlledTextArea-module-scss-module__VnJNyG__header-1",
  "input_error": "ControlledTextArea-module-scss-module__VnJNyG__input_error",
  "main-container": "ControlledTextArea-module-scss-module__VnJNyG__main-container",
  "main-footer-container": "ControlledTextArea-module-scss-module__VnJNyG__main-footer-container",
  "main-header-container": "ControlledTextArea-module-scss-module__VnJNyG__main-header-container",
  "textarea": "ControlledTextArea-module-scss-module__VnJNyG__textarea",
  "textarea_disabled": "ControlledTextArea-module-scss-module__VnJNyG__textarea_disabled",
  "textarea_error": "ControlledTextArea-module-scss-module__VnJNyG__textarea_error",
  "txt-12-bold": "ControlledTextArea-module-scss-module__VnJNyG__txt-12-bold",
  "txt-14-bold": "ControlledTextArea-module-scss-module__VnJNyG__txt-14-bold",
  "txt-14-bold-caps": "ControlledTextArea-module-scss-module__VnJNyG__txt-14-bold-caps",
  "txt-14-med": "ControlledTextArea-module-scss-module__VnJNyG__txt-14-med",
  "txt-16-bold": "ControlledTextArea-module-scss-module__VnJNyG__txt-16-bold",
  "txt-16-med": "ControlledTextArea-module-scss-module__VnJNyG__txt-16-med",
  "txt-18-bold": "ControlledTextArea-module-scss-module__VnJNyG__txt-18-bold",
  "txt-18-medium": "ControlledTextArea-module-scss-module__VnJNyG__txt-18-medium",
  "txt-18-medium-24": "ControlledTextArea-module-scss-module__VnJNyG__txt-18-medium-24",
  "txt-24-semi": "ControlledTextArea-module-scss-module__VnJNyG__txt-24-semi",
  "wrapper": "ControlledTextArea-module-scss-module__VnJNyG__wrapper",
  "wrapper__label": "ControlledTextArea-module-scss-module__VnJNyG__wrapper__label",
});
